(function() {

  'use strict';

  function MercadoLivreResource($resource, PUBLIC_API) {
    return $resource(PUBLIC_API, {}, {
      authorize: {
        method: 'POST',
        url: PUBLIC_API + '/ml/authorize'
      },
      getEmail: {
        method: 'POST',
        url: PUBLIC_API + '/ml/user_data'
      },
      logoutML: {
        method: 'POST',
        url: PUBLIC_API + '/ml/disconnect'
      }
    });
  }

  angular
    .module('mandaeApp')
    .factory('MercadoLivreResource', MercadoLivreResource);
})();
